<h2 style="margin-bottom: 10px; text-align: center">
  El agente perdió la conexión
</h2>
<p style="text-align: justify">
  El agente que te estaba atendiendo perdió la conexión. Puedes esperarlo o dar click en el botón "Volver a la cola" para contactar a otro agente.
</p>
<div style="display: flex; justify-content: center; margin-top: 20px">
  <button mat-raised-button color="primary">Volver a la cola</button>
</div>
